module.exports = __webpack_public_path__ + "c0d5de17d185e4929c7e68f1d0401a29.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsolutions/assets/11-Betsolutions-Bura.png
// module id = 1733
// module chunks = 2